import { CommonModule, DatePipe } from '@angular/common';
import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  Output,
  EventEmitter,
  OnChanges,
  ViewChild,
  TemplateRef,
  inject,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzCardModule } from 'ng-zorro-antd/card';
import { UploadComponent, ListTableComponent } from '@ppl/ui';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzI18nService } from 'ng-zorro-antd/i18n';
import { ReferralDataService } from '../../../../../services/referral-data.service';
import { SectionsService } from '../../../../../services/sections.service';
import { LeadDetailsService } from '../../../../../services/lead-details.service';
import {
  STATIC_JSON_DATA_PATH,
  STATIC_DATA,
} from '../../../../../shared/constants/static-data.constants';
import { BaseComponent } from '../../../../../shared/utils/base.component';
import { LoggerService } from '../../../../../shared/services/logger.service';
import { TableRowActionsModel } from '../../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../../shared/interfaces/actions';
import { ListService } from '../../../../../shared/services/list.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SharedDataService } from '../../../../../shared/services/shared-data-service';
import { SharedService } from '../../../../../shared/services/shared.service';
import { ButtonComponent } from '@ppl/ui';
import { UserService } from '../../../../../services/user.service';
import {
  DialogConfig,
  DialogService,
} from '../../../../../shared/services/dialog.service';
import { DropdownSelectComponent } from '@ppl/ui';
import { environment } from '../../../../../../environments/environment';
import { FileUploadNotificationService } from '../../../../../services/file-upload-notification.service';
import {
  AcknowledgeItem,
  AcknowledgeFileUploadNotificationResponse,
  FileUploadNotificationData
} from '../../../../../interfaces/file-upload-notification.interface';
import { finalize } from 'rxjs/operators';
import { NotificationService } from '../../../../../shared/services/notification.service';
import { UploadHandlerService } from '../../../../../shared/services/upload-handler.service';
import { MEMBER_VIEW_PAGE_IDS, TABS } from 'src/app/shared/constants/page.constants';
import { AuthorizationUtility } from 'src/app/shared/authorization/auth.utility';
@Component({
  selector: 'ppl-file-upload',
  standalone: true,
  imports: [
    NzToolTipModule,
    NzSelectModule,
    NzFormModule,
    NzInputModule,
    NzTimePickerModule,
    ReactiveFormsModule,
    NzCheckboxModule,
    NzCardModule,
    UploadComponent,
    NzRadioModule,
    NzIconModule,
    NzButtonModule,
    NzToolTipModule,
    ListTableComponent,
    CommonModule,
    ButtonComponent,
  ],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.css',
})
export class FileUploadComponent
  extends BaseComponent
  implements OnInit, OnChanges {
  servicesForm!: FormGroup;
  uploadForm: FormGroup = this.fb.group({
    document_type: [''],
    other_type: [''],
  });
  fileList: any;
  @Input() filedInfo: any;
  @Input() tableWidth?: any;
  @Input() summary?: any;
  mode = 'read';
  steps: any = {};
  cols: any;
  fileListInfo: any[] = [];
  actionButtons: TableRowActionsModel = new TableRowActions({ edit: true });
  program: any;
  //entry: any;
  filledInfo: any;
  approvedStatus: string = STATIC_DATA.APPROVED;
  leadStatus = '';
  leadStatusRaw?: string;
  leadId: string | null = '';
  licences: any[] = [];
  fileId = '';
  customType = '';
  message: any =
    'Please select a document type and upload supporting documents for it';
  selectedForAck: AcknowledgeItem[] = [];
  programCode = this.userService.getSelectedProgram()?.program_code ?? '';
  isAckLoading = false;
  fileDetailsArr: any[] = [];
  @Input() flow: any;
  type: any;
  statusReady = false;
  isSectionEditable = false;
  isSectionDeletable = false;
  private applicationSubmitted = '';
  pageId = '';
  tabId = TABS.Documents;

  private getRowId(r: any): number {
    return Number(r?.fileId ?? r?.leadFileId ?? r?.leadfileId ?? r?.id);
  }
  public isAcked = (r: any) => {
    const v = r?.acknowledged === true || r?.is_acknowledged === true || r?.isAcknowledged === true;
    return v;
  };


  private isEligibleForAck = (r: any): boolean => !!r && !this.isAcked(r);


  @Input() set sectionData(data: any) {
    this.steps = data;
  }

  @Input() entry = 'base';
  @Input() readonly = false;
  @Input() showButtons? = true;
  @Input() showUpload? = true;
  @Input() selectedLead = 0;
  @Input() authId? = null;
  @Output() filesUpdated = new EventEmitter();
  @ViewChild('fileEditDialog') fileEditDialog!: TemplateRef<any>;

  private dialogSvc = inject(DialogService);

  constructor(
    private sectionsService: SectionsService,
    private leadDetailsService: LeadDetailsService,
    private logger: LoggerService,
    private sharedDataService: SharedDataService,
    private sharedService: SharedService,
    private userService: UserService,
    private fb: FormBuilder,
    private fileUploadNotificationService: FileUploadNotificationService,
    private msg: NzMessageService,
    private cdr: ChangeDetectorRef,
    private notificationService: NotificationService,
    private uploadHandler: UploadHandlerService,
    private authUtility: AuthorizationUtility,
  ) {
    super();
    this.pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
  }

  get isAckSupported(): boolean {
    const entry = (this.entry ?? '').toLowerCase();
    if (['referral', 'auth', 'provider'].includes(entry)) {
      return false;
    }
    // if (entry === 'participantenrollment' || entry === 'providerenrollment') {
    //   return (this.leadStatus ?? '').toLowerCase() === 'in ppl review';
    // }

    return false;
  }

  get canAckSelected(): boolean {
    return Array.isArray(this.selectedForAck) && this.selectedForAck.length > 0;
  }


  ngOnInit(): void {
    console.log('FLOW CHECK => entry:', this.entry);
    // console.log("filedinfo in file com, this.fil", this.filedInfo)
    this.program = this.userService.getSelectedProgram();
    this.flow = this.sectionsService.getFlow();
    this.type = this.flow || this.userService.getLeadEntry();
    this.isSectionEditable = this.readonly ? false : this.authUtility.isSectionEditable(this.pageId, this.tabId, 'FileUpload');
    this.isSectionDeletable = this.readonly ? false : this.authUtility.isSectionDeletable(this.pageId, this.tabId, 'FileUpload');
    this.leadId = this.userService.getSelectedLead() ?? '';
    if (this.entry === 'auth' && this.authId != null) {
      this.leadId = this.authId;
    }
    const enrollType = this.sectionsService.getEnrollmentType();
    if (this.entry === 'participantEnrollment') {
      this.licences = this.getLookup('Upload_Doc_Type');
    }
    else if(this.entry === 'referral'){
      this.licences = this.getLookup('License_Type_Referral');
    }
    else if(this.entry === 'auth'){
      this.licences = this.getLookup('License_Type_Auth');
    } else if (enrollType && Array.isArray(enrollType)) {
      // Map each enrollment type to its document type domain
      const domainMap: Record<string, string> = {
        'provider': 'License_Type_IP',
        'vendor': 'License_Type_Vendor',
        'contractor': 'License_Type_IC',
        'employer': 'License_Type_Employer',
        'independentFacilitator': 'License_Type_IF',
        'authRepresentative': 'License_Type_AR',
      };

      // Collect doc types from all enrolled types, dedup by lkpValueCode
      const uniqueTypes = [...new Set<string>(enrollType)];
      const docTypeMap = new Map<string, any>();
      for (const type of uniqueTypes) {
        const domain = domainMap[type];
        if (domain) {
          const lookupValues = this.getLookup(domain) ?? [];
          for (const item of lookupValues) {
            if (!docTypeMap.has(item.lkpValueCode)) {
              docTypeMap.set(item.lkpValueCode, item);
            }
          }
        }
      }
      this.licences = docTypeMap.size > 0 ? Array.from(docTypeMap.values()) : this.getLookup('License_Type');

      // if enrollType includes conservator, legal guardian or poa then show only 'Other' document type
      if (this.sectionsService.getFlow() === STATIC_DATA.PROVIDER_ENROLLMENT &&
        (enrollType.includes('legalGuardian') || enrollType.includes('poa') || enrollType.includes('conservator'))) {
        this.licences = this.licences.filter((license: any) => license.lkpValueCode === 'OTH');
      }
    } else {
      this.licences = this.getLookup('License_Type');
    }
    this.getFromData();
    if (this.entry === 'auth') {
      this.message = 'Please upload supporting documents'
    }
    this.leadDetailsService.getLeadStatus().subscribe((status: string) => {
      this.leadStatusRaw = status ?? '';
      this.leadStatus = (status ?? '').trim().toLowerCase();
      console.log(this.leadStatus);
      this.statusReady = true;
      this.cdr?.markForCheck?.();

      if (this.leadStatus === this.approvedStatus) {
        this.actionButtons.download = false;
        this.actionButtons.delete = false;
        this.actionButtons.edit = false;
      } else {
        this.actionButtons.download = true;
        this.actionButtons.delete = this.isSectionDeletable;
        this.actionButtons.edit = this.isSectionEditable;
      }
    });
    this.leadDetailsService.getUpdatedLeadData().subscribe((data) => {
      this.filledInfo = data?.responsedata?.infoData;
      this.leadStatus = this.filledInfo?.applicationStatus;
      const raw = (this.filledInfo?.applicationStatus ?? '').trim();
      this.leadStatusRaw = raw;
      this.leadStatus = raw.toLowerCase();
      this.statusReady = true;
      this.cdr?.markForCheck?.();
    });
  }

  private resolveUserType(): 'participant' | 'provider' {
    const map: Record<string, 'participant' | 'provider'> = {
      participantenrollment: 'participant',
      providerenrollment: 'provider',
      provider: 'provider',
    };
    const key = (this.entry ?? '').toString().toLowerCase().trim();
    return map[key] ?? 'participant';
  }
  private toAckItem(row: any): AcknowledgeItem {
    const fileId = row.fileId ?? row.leadFileId ?? row.leadfileId ?? row.file_id ?? row.id;
    const userType = this.resolveUserType();
    return { fileId: Number(fileId), userType };
  }
  onSelectionChange(rows: any[]): void {
    const incoming = Array.isArray(rows) ? rows : [];
    if (!incoming.length) {
      this.selectedForAck = [];
      return;
    }
    const byId = new Map<number, any>(
      (this.fileListInfo ?? []).map((r: any) => [this.getRowId(r), r])
    );
    const normalized: any[] = incoming
      .map((it: any) => byId.get(Number(it?.fileId ?? it?.leadFileId ?? it?.id)))
      .filter(Boolean);
    const eligibleRows = normalized.filter(
      (r: any) => !this.isAcked(r) && this.isEligibleForAck(r)
    );
    const payload = eligibleRows.map((r: any) => this.toAckItem(r));
    const dropped = incoming.length - payload.length;
    if (dropped > 0) {
      this.fileListInfo = [...(this.fileListInfo ?? [])];
    }
    this.selectedForAck = payload;
    console.log(
      '[onSelectionChange]',
      { incoming: incoming.length, normalized: normalized.length, eligible: eligibleRows.length, dropped },
      'selectedForAck →', this.selectedForAck
    );
  }
  public onAcknowledgeClicked(): void {
    if (!this.isAckSupported) { return; }
    if (!this.selectedForAck || this.selectedForAck.length === 0) { return; }
    const byId = new Map<number, any>(
      (this.fileListInfo ?? []).map((r: any) => [this.getRowId(r), r])
    );
    const payload: AcknowledgeItem[] =
      (this.selectedForAck ?? []).filter(it => {
        const cur = byId.get(Number(it.fileId));
        return !!cur && !this.isAcked(cur);
      });
    if (payload.length === 0) { return; }
    const payloadCount = payload.length;
    this.isAckLoading = true;
    this.fileUploadNotificationService
      .acknowledgeFilesLite(payload, this.programCode)
      .pipe(finalize(() => (this.isAckLoading = false)))
      .subscribe({
        next: () => {
          const userType = this.resolveUserType();
          this.notificationService.alert('success',
            'Success',
            `Successfully acknowledged ${payloadCount} file${payloadCount === 1 ? '' : 's'}.`
          );
          this.selectedForAck = [];
          this.fileListInfo = (this.fileListInfo ?? []).map(r => ({ ...r }));
          this.cdr.detectChanges();
          this.refreshList(false);
        },
        error: () => this.msg.error('Error acknowledging file(s).')
      });
  }
  private refreshList(preserveOnEmpty = false): void {
    this.isAckLoading = true;
    this.sharedService
      .getUploadedFileDetails(this.programCode, this.leadId, this.type, true)
      .pipe(finalize(() => (this.isAckLoading = false)))
      .subscribe({
        next: (res: any) => {
          const rd = res?.responseData ?? {};
          const rows: any[] =
            Array.isArray(rd.participantEnrIDocumentDetails) ? rd.participantEnrIDocumentDetails :
              Array.isArray(rd.referralDocumentDetails) ? rd.referralDocumentDetails :
                (Object.values(rd).find((v: any) => Array.isArray(v)) as any[]) || [];
          if (preserveOnEmpty && rows.length === 0 && (this.fileListInfo?.length ?? 0) > 0) {
            console.warn('[refreshList] Empty rows from API; preserving current grid.');
            return;
          }
          this.selectedForAck = [];
          this.fileListInfo = [];
          setTimeout(() => {
            this.fileListInfo = rows;
            this.filesUploaded([...rows]);
            console.log('[refreshList] rows loaded:', rows.length);
          }, 0);
        },
        error: () => this.msg.error('Error refreshing file list.')
      });
  }
  filesUploaded(files: any) {
    console.log('Files List', files);
    this.fileList = files;
    this.selectedForAck = [];
    this.filesUpdated.emit();
  }

  // Handle raw file selection from ppl-ui — upload via SharedService then refresh
  onFileSelected(event: any) {
    const file = event?.file as File;
    if (!file) return;
    const program = this.userService.getSelectedProgram()?.program_code ?? '';
    const type = this.flow || this.userService.getLeadEntry();
    const flowName = (type === 'authorizations') ? 'auth' : this.sharedDataService.getType(type);

    const formData = new FormData();
    formData.append('file', file as any);
    const requestPayload: any = {
      fileType: file.name.split('.').pop() || '',
      otherType: event.documentType || '',
      program,
      type: flowName,
      ...(flowName === 'auth' ? { authDetailId: event.leadId } : { leadId: event.leadId })
    };
    if ((event.consumerId && event.providerId) || (event.source === 'purchaserequest' && event.consumerId)) {
      Object.assign(requestPayload, {
        consumerId: event.consumerId,
        providerId: event.providerId,
        type: event.source || type
      });
    }

    formData.append('json', new Blob([JSON.stringify(requestPayload)], { type: 'application/json' }));

    this.uploadHandler.uploadFromEvent(event, type).subscribe({
      next: () => this.refreshList(false),
      error: () => this.notificationService.error('Error', `${file.name} file upload failed.`)
    });
  }

  onFileRemoved(fileId: any) {
    const id = fileId;
    const createType = this.leadId ? 'detail' : 'new';
    const docSource = this.entry || this.type || '';
    const program = this.userService.getSelectedProgram()?.program_code ?? '';
    this.uploadHandler.deleteFile(program, id, createType, docSource).subscribe(() => this.refreshList(false));
  }

  onDownloadRequested(file: any) {
    this.uploadHandler.downloadFile(file, this.entry || this.type || '');
  }

  onUploadError(payload: any) {
    this.uploadHandler.handleUploadError(payload);
  }

  cancelEdit() {
    this.mode = 'read';
    //this.leadUpdated.emit(true);
    //need to rest the form
    //this.contactForm.reset();
  }

  async getFromData() {
    try {
      if (this.entry) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.LEAD_DETAILS_DOCUMENT_LIST_HEADERS,
          this.entry
        );
        this.cols = tempCols.documents.columns;
        console.log(this.cols);
      }
    } catch (e) {
      this.log.debug('Error in getting column data', e);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (changes['filedInfo'] && changes['filedInfo'].currentValue) {
        this.fileListInfo =
          this.entry === STATIC_DATA.PROVIDER
            ? changes['filedInfo'].currentValue.providerDocumentDetails
            : this.entry === STATIC_DATA.REFERRAL
              ? changes['filedInfo'].currentValue.referralDocumentDetails
              : this.entry === 'providerEnrollment'
                ? changes['filedInfo'].currentValue.providerEnrlDocumentDetails
                : this.entry === 'auth'
                  ? changes['filedInfo'].currentValue.consumerAuthDocumentDetailsList
                  : changes['filedInfo'].currentValue.participantEnrlDocumentDetails;
        this.logger.info(
          'fileListInfo',
          changes['filedInfo'].currentValue.providerDocumentDetails
        );
        if (!this.fileListInfo) {
          this.fileListInfo = [];
        }
        this.fileListInfo = this.fileListInfo.map((item) => {
          if (item.lkpValueName === null && item.otherType) {
            return { ...item, lkpValueName: item.otherType };
          }
          return item;
        });
        console.log('File List', this.fileListInfo);
      }
    } catch (e) {
      this.logger.info(
        'Error in getting section data and updating latest info',
        e
      );
    }
  }

  action(event: any): void {
    this.logger.debug('Action', event);
    const selectedFileName = event.data.fileName;

    switch (this.entry) {
      case STATIC_DATA.REFERRAL:
        this.fileId = event.data.referralFileId;
        break;
      case STATIC_DATA.PARTICIPANT_ENROLLMENT:
        this.fileId = event.data.leadFileId;
        break;
      case STATIC_DATA.PROVIDER_ENROLLMENT:
        this.fileId = event.data.fileId;
        break;
      case 'auth':
        this.fileId = event.data.fileId;
        break;
      default:
        this.fileId = event.data.leadFileId;
    }
    // : event.data.referralFileId;
    // let flow = entry.charAt(0).toUpperCase() + entry.slice(1).toLowerCase();
    if (event.action === 'download') {
      this.mode = 'edit';
      this.fecthcFile(selectedFileName, this.fileId);
      // this.servicesForm.patchValue(event.data);
    }
    if (event.action === 'delete') {
      this.mode = 'edit';
      this.deleteFile();
      // this.servicesForm.patchValue(event.data);
    }
    if (event.action === 'edit') {
      console.log(event);
      this.mode = 'edit';
      this.uploadForm.patchValue({ document_type: event.data.otherType });
      this.openEditFileDialog(true);
    }
  }

  openEditFileDialog(preserveErrors = false) {
    if (!preserveErrors) {
      this.validationErrors = {};
    }
    const dialogConfig: DialogConfig = {
      title: `File Type`,
      okText: 'Update',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
      preventDuplicates: false,
    };

    this.dialogSvc.openDialog(
      this.fileEditDialog,
      dialogConfig,
      () => this.handleUpdate(),
      () => this.handleCancel()
    );
  }

  handleUpdate() {
    const docType = this.uploadForm.get('document_type')?.value;
    const otherType = this.uploadForm.get('other_type')?.value?.trim();

    // Validate that a valid document type is selected
    const isValidDocType = docType && this.licences.some((l: any) => l.lkpValueCode === docType);
    if (!isValidDocType) {
      this.validationErrors['document_type'] = 'Please select a valid document type';
      this.openEditFileDialog(true);
      return;
    }

    // If 'Other' is selected, document name is mandatory
    if (docType === 'OTH' && !otherType) {
      this.validationErrors['other_type'] = 'Document name is required';
      this.openEditFileDialog(true);
      return;
    }

    this.validationErrors = {};

    const payload = {
      otherType: '',
    };
    if (docType === 'OTH') {
      payload.otherType = otherType;
    } else {
      payload.otherType = docType;
    }

    this.sharedService
      .updateFile(
        this.program.program_code,
        this.fileId,
        payload,
        this.sharedDataService.getType(this.entry)
      )
      .subscribe((data: any) => {
        console.log(data);
        this.filesUpdated.emit();
      });
  }

  handleCancel() {
    this.validationErrors = {};
  }

  docTypeChanged(event: any) {
    console.log(this.uploadForm.get('document_type')?.value);
    this.validationErrors = {};
    if (event === 'OTH') {
      this.uploadForm.get('other_type')?.setValue('');
    }
  }

  add(): void {
    this.mode = 'add';
  }

  deleteFile() {
    const createType = this.leadId === '' ? 'new' : 'detail';
    this.sharedService
      .deleteFile(
        this.program.program_code,
        this.fileId,
        createType,
        this.sharedDataService.getType(this.entry)
      )
      .subscribe((data: any) => {
        console.log(data);
        // this.msg.success(`File deleted successfully`);
        this.filesUpdated.emit();
      });
  }

  save() {
    //added update functionality for licenses
    // let payLoad:any={};
    // let servicesRendered: any=[];
    // this.servicesForm.controls['profLicences'].value.map((x: any)=>servicesRendered.push({serviceType:x}))
    // console.log(this.filledInfo.contactDetailsData.leadId)
    // payLoad={
    //   'leadId': this.filledInfo.contactDetailsData.leadId,
    //   'servicesRendered':servicesRendered
    // }
    // this.leadDetailsService.updateProfessionalLicense(payLoad, this.entry).subscribe(() => {
    //   this.logger.info('Lead Provider Service is sucessfully updated!');
    //   //this.servicesForm.reset();
    //   this.leadUpdated.emit(true);
    //   this.mode = 'read'
    // })
  }

  editInfo() {
    this.mode = 'edit';
    // this.patchLicenseData();
    // this.contactForm.patchValue(this.filledInfo);
    // this.contactForm.controls['leadId'].setValue(this.filledInfo?.permanentAddress?.leadId || this.selectedLeadId);
  }

  // downloadFileFromServer(fileUrl: string) {
  //   this.http.get(fileUrl, {responseType: 'blob'}).subscribe((blob) => {
  //   })
  // }

  fecthcFile(selectedFileName: string, fileId: string) {
    this.sharedService.downloadFile(
      this.program.program_code,
      this.sharedDataService.getType(this.entry),
      fileId,
      selectedFileName
    );
  }
}
